import React, { useState, useEffect } from 'react'

import { FetchApproveCorrection, FetchReadOutgoingTransactions, FetchArticleTypeImages } from '../../../fetcher'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { ModalView } from '../../_reusedcomponents/ModalView'
import { OutgoingTransactionsTableContainer } from './OutgoingTransactionsTableContainer'
import { useHandleAlertMessage, useHandleMask } from '../../../utils/togglinghooks'
import { CreateTransactionContainer } from '../addtransactions/CreateTransactionContainer'

/**
 * Container Component for outgoing transcations. 
 * Fetches all kind of data related to the child views displaying outgoing transactions.
 * Acts as a wrapper for ModalViews and AlertMessage
*/
const OutgoingTransactionsContainer = () => {

    const [outgoingTransactions, setOutgoingTransactions] = useState([])
    const [articleDataReady, setArticleDataToReady] = useState(false)

    const [showMaskDelivery, handleShowMaskDelivery, handleCloseMaskDelivery] = useHandleMask()
    const [showMaskDeliveryDraft, handleShowMaskDeliveryDraft, handleCloseMaskDeliveryDraft] = useHandleMask()
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()

    const [draftToUpdate, setDraftToUpdate] = useState()
    const [showCorrectionModal, setShowCorrectionModel] = useState(false)
    const [confirmTransactionSysId, setTransactionSysId] = useState("")
    const handleCloseCorrectionModal = () => setShowCorrectionModel(false)

    /**
     * Sets the outgoing transactions array with filtered values corresponding to this view.
     * @param {object[]} transactions array of transactions
     */
    const handleSetOutgoingTransactions = (transactions) => {
        setOutgoingTransactions(transactions.filter(x => x.State !== "Confirmed" && x.Type !== "Sales"))
    }

    /**
     * Adds the corresponding images to the fetched transactions articleTypes via SysIds.
     * @param {object[]} articleTypeImages image datas as binary string
     */
    const addingImages = (articleTypeImages) => {
        let copiedOutgoingTransactions = [...outgoingTransactions]
        articleTypeImages.forEach(image => copiedOutgoingTransactions.flatMap(x => x.Articles).filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setOutgoingTransactions(copiedOutgoingTransactions)
    }

    /**
     * Fetches outgoing transactions and sets them as array
     * sets bool articleDataReady to start image fetching
    */
    useEffect(() => {
        FetchReadOutgoingTransactions(handleSetOutgoingTransactions, openAlert, setArticleDataToReady)
    }, []);

    /**
     * Fetches images for articleTypes via SysIds if they are already fetched
    */
    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(outgoingTransactions.flatMap(x => x.Articles).map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    /**
     * Reload function for refetching outgoingTransactions if a new one was created
    */
    const reload = () => {
        FetchReadOutgoingTransactions(setOutgoingTransactions, openAlert, setArticleDataToReady)
    }

    /**
     * Sets visibility of correction model.
     * @param {string} transactionSysId string of the transactionSysId to be corrected
     */
    function handleShowCorrectionModal(transactionSysId) {
        setShowCorrectionModel(true)
        setTransactionSysId(transactionSysId)
    }

    /**
     * Handles the confirmation of a correction added by the user. Starts a fetch call with state change.
    */
    const handleApproveCorrection = () => {
        if (confirmTransactionSysId != "") {
            const stateChangeModel = {
                AbstractTransactionSysId: confirmTransactionSysId,
                OldState: "InProcess"
            };

            FetchApproveCorrection(stateChangeModel, handleCloseCorrectionModal, reload)
        }
    }

    return(
        <>
            <OutgoingTransactionsTableContainer
                outgoingTransactions={outgoingTransactions}
                openAlert={openAlert} reload={reload} setDraftToUpdate={setDraftToUpdate}
                handleShowMaskDeliveryDraft={handleShowMaskDeliveryDraft} handleShowMaskDelivery={handleShowMaskDelivery} handleShowCorrectionModal={handleShowCorrectionModal} />

            <ModalView handleShow={showCorrectionModal} handleClose={handleCloseCorrectionModal} handleSubmit={handleApproveCorrection}
                reload={reload} modalTitle="Korrektur akzeptieren" modalBody="Möchten Sie die Korrektur für diesen Lieferschein wirklich akzeptieren?" />

            <ModalView handleShow={showMaskDelivery} handleClose={handleCloseMaskDelivery}
                reload={reload} modalTitle="Neuer Lieferschein" modalBody={<CreateTransactionContainer handleCloseMask={handleCloseMaskDelivery} reloadParent={reload} />}
                extendedView={true} formTitle="delivery-order-submit" />

            <ModalView handleShow={showMaskDeliveryDraft} handleClose={handleCloseMaskDeliveryDraft}
                reload={reload} modalTitle="Lieferschein-Entwurf bearbeiten" modalBody={<CreateTransactionContainer handleCloseMask={handleCloseMaskDeliveryDraft} reloadParent={reload} draft={draftToUpdate} />}
                extendedView={true} formTitle="delivery-order-submit" />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </>
    )
}

export { OutgoingTransactionsContainer }